import { defineNuxtRouteMiddleware } from 'nuxt/app'

export default defineNuxtRouteMiddleware(async (to, from) => {
    const router = useRouter();
    const { status, getSession }: any = useAuth();

    await getSession();

    if(status.value === 'authenticated') {
        try {
            const { data, status } = await useApi('/api/user/account/me', {
                method: 'GET',
            });

            if(data && status == 'success') {
                console.log('me account: ', data)
            }

        } catch(error: any) {
            if (error.response) {
                const { statusCode, errorMessage, serverErrorMessage, serverErrorObject } = error.response._data?.error || {};

                console.error('Error', {
                    statusCode: statusCode,
                    errorMessage: errorMessage,
                    serverErrorMessage: serverErrorMessage,
                    serverErrorObject: serverErrorObject
                })

                showNotificationError(serverErrorMessage);
                console.log('status code', statusCode)
                if(
                    statusCode === 401 || 
                    statusCode === 403 ||
                    statusCode === 500
                ) {
                    router.push('/login');
                }
    
            } else {
                console.error("Unexpected error:", error);
            }
        }
    }

});
